var map = {
	"./EventLuckyDraw.jsx": 83069,
	"./EventPassPage.jsx": 18021,
	"./LuminaRecipesPage.jsx": 39668,
	"./Map.jsx": 93852,
	"./NonVegRecipeUI.jsx": 24602,
	"./PageType-0.jsx": 24929,
	"./PageType-1.jsx": 51133,
	"./PageType-17.jsx": 37658,
	"./PageType-18.jsx": 29206,
	"./PageType-19.jsx": 91382,
	"./PageType-2.jsx": 71766,
	"./PageType-3.jsx": 83167,
	"./PageType-4.jsx": 79737,
	"./PageType-5.jsx": 42077,
	"./PageType-6.jsx": 52898,
	"./PageType-7.jsx": 14826,
	"./PageType-8.jsx": 97782,
	"./PageType-9.jsx": 1968,
	"./VegRecipeUI.jsx": 31669,
	"./calltoaction.jsx": 52698,
	"./qr-code.jsx": 9557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4176;